export interface ViolationOption {
	label: string;
	value: string;
	type?: string;
	category?: ViolationOption[];
}

export const VIOLATION_OPTIONS: ViolationOption[] = [
	{
		label: 'violations.all_violation',
		value: 'all',
		category: [
			{ label: 'violation.category_law', value: 'law' },
			{ label: 'violation.category_custom', value: 'general' },
			{ label: 'violation.category_operations', value: 'company' },
		],
	},
	{
		label: 'violations.approved_violation',
		value: 'approved',
		category: [
			{ label: 'violation.category_law', value: 'law' },
			{ label: 'violation.category_custom', value: 'general' },
			{ label: 'violation.category_operations', value: 'company' },
		],
	},
	{
		label: 'violations.unapproved_violation',
		value: 'unapproved',
		category: [
			{ label: 'violation.category_law', value: 'law' },
			{ label: 'violation.category_custom', value: 'general' },
			{ label: 'violation.category_operations', value: 'company' },
		],
	},
] as const;

export const OTHER: string = 'other';
export const UI_COLORS: Record<string, string> = {
	VIOLATION_APPROVED: '#F9D2D3',
	VIOLATION_CRITICAL: '#9A191E',
	VIOLATION_UNAPPROVED: '#E55F64',

	PREF_MET: '#5B87EC',
	PREF_NOT_MET_STRIPED: '#5B87EC',
	PREF_PARTIAL: '#CBD8F5',
	PREF_UNMET_GREY: '#757575',

	ABSENCE_HIGH: '#EC8B0B',
	ABSENCE_LOW: '#F8CF99',
	ABSENCE_LEGACY_APPROVED: '#776347',
	ABSENCE_LEGACY_PENDING: '#BEA683',

	PREF_WORK_DAY: '#C4DF86',

	BG_DEFAULT: '#F5F5F5',
	BG_SUNDAY_REST: '#EBF9FF',
	BG_WHITE: '#FFFFFF',

	TEXT_VACATION: '#B09269',
	TEXT_DEFAULT: '#424242',
};

export const STORAGE_KEYS = {
	EXPANDED: 'scheduler_is_expanded',
	SCROLL_TOP: 'scheduler_scroll_top',
	SHOW_UNALLOCATED: 'show_unallocated',
	INDICATOR_FILTERS: 'indicatorFilters',
	PLANNING_TABLE_DATA: 'PlanningTableData',
	SHOW_UNALLOCATED_DRIVERS: 'show_unallocated_drivers',
	VERTICAL_UNALLOCATED_EXPANDED: 'scheduler_vertical_unallocated_expanded',
	PREVIEW_PANEL_OPEN: 'preview_panel_open',
	PREVIEW_ACTIVE_TAB: 'preview_active_tab',
};

export const PLANNING_DAY_STATUS = {
	PAST: 'past',
	PLANNING: 'planning',
	PREVIEW: 'preview',
	PUBLISHED: 'published',
	OPEN: 'open',
	LOCKED: 'locked',
};

export const DUTY_TYPE = {
	ABSENCE: 'absence',
	VACATION: 'vacation',
};

export const HISTORIES = {
	DUTY: 'duty',
	USER: 'user',
};

export const PLANNING_DIALOG_TABS = {
	DISPOSITION: 'disposition',
	DUTY_DETAILS: 'dutyDetails',
	DUTY_ACTIVITIES: 'dutyActivities',
	REPORTS: 'reports',
	HISTORY: 'history',
};

export const SECONDS_IN_DAY = 86400;
export const STORAGE_VIEW_KEY = 'date_picker_selected_view';
export const STORAGE_DISPOSITION_KEY = 'date_picker_disposition_config';
export const SCROLL_STORAGE_KEY = 'scheduler_scroll_positions';
